import { render, staticRenderFns } from "./player-redemption-history.vue?vue&type=template&id=fe4d6592&"
import script from "./player-redemption-history.vue?vue&type=script&lang=js&"
export * from "./player-redemption-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports